import * as actions from './actions';

const initialState = {
	configs: [],
	config: null,
	saving: false,
	loading: false,
	error: false,
	errorDetail: null
};

function reduceClearConfigError(state) {
	return {
		...state,
		saving: false,
		loading: false,
		error: false,
		errorDetail: null
	};
}

function reduceFetchConfig(state) {
	return {
		...state,
		loading: true,
		error: false,
		config: null
	};
}

function reduceFetchSuccess(state, action) {
	return {
		...state,
		config: action.payload,
		loading: false,
		error: false,
		errorDetail: null
	};
}

function reduceListConfigs(state) {
	return {
		...state,
		loading: true,
		error: false,
		configs: []
	};
}

function reduceListSuccess(state, action) {
	return {
		...state,
		configs: action.payload,
		loading: false,
		error: false,
		errorDetail: null
	};
}

function reduceSaveStart(state) {
	return {
		...state,
		saving: true,
		error: false
	};
}

function reduceSaveSuccess(state) {
	return {
		...state,
		saving: false,
		error: false,
		errorDetail: null
	};
}

function reduceSaveError(state, action) {
	return {
		...state,
		error: true,
		errorDetail: action.payload
	};
}

function reduceError(state, action) {
	return {
		...state,
		error: true,
		errorDetail: action.payload,
		loading: false
	};
}

export const config = (state, action) => {
	state = state || initialState;
	switch (action.type) {
		case actions.CLEAR_CONFIG_ERROR :
			return reduceClearConfigError(state);
		case actions.FETCH_CONFIG :
			return reduceFetchConfig(state);
		case actions.FETCH_CONFIG_SUCCESS :
			return reduceFetchSuccess(state, action);
		case actions.FETCH_CONFIG_ERROR :
			return reduceError(state, action);
		case actions.SAVE_CONFIG :
			return reduceSaveStart(state);
		case actions.SAVE_CONFIG_SUCCESS :
			return reduceSaveSuccess(state);
		case actions.SAVE_CONFIG_ERROR :
			return reduceSaveError(state, action);
		case actions.LIST_CONFIGS :
			return reduceListConfigs(state);
		case actions.LIST_CONFIGS_SUCCESS :
			return reduceListSuccess(state, action);
		case actions.LIST_CONFIGS_ERROR :
			return reduceError(state, action);
		default:
			return state;
	}
};
